module.exports = __webpack_public_path__ + "assets/img/login_left_bg.2153f5a5.png";